import React, { useState, useEffect, useRef } from 'react'
import { Avatar, List, Button, Modal, Badge, Empty } from 'antd'
import {
  PlusCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons'
import { useDrop } from 'react-dnd'

import AdicionarVendedorFilaWrapper from './AdicionarVendedorFilaWrapper'
import SairDaFila from './SairFila/SairFila'
import DiarioVendedor from '../../pages/diarioVendedor/DiarioVendedor'
import EncerrarAtendimento from './EncerrarAtendimento/EncerrarAtendimento'
import BotaoAcaoFlutuante from '../BotaoAcao/BotaoAcao'
import MenuMaisOpcoes from './MenuMaisOpcoes/MenuMaisOpcoes'
import IconFont from '../iconFont/IconFont'
import CustomDateFNS from '../custom-date-fns/CustomDateFNS.container'

import {
  ausentarVendedor,
  editAtendimento,
  entrarNaFila,
  formatarNome,
  iniciarAtendimento,
  marcarFeedbackLido,
} from '../../pages/fila/Functions-Fila'

import './VendedoresDisponiveis.css'
import FeedbackWrapper from './FeedbackWrapper'
// import { SaleCelebration } from '../Animacoes/SallesCelebration'

const { confirm } = Modal

function VendedoresDisponiveis (props) {
  const [tipoEncerramento, setTipoEncerramento] = useState('')
  const [mostrarSaidaVendedor, setMostrarSaidaVendedor] = useState(false)
  const [vendedor, setVendedor] = useState({})
  const [mostrarAdicionarVendedor, setMostrarAdicionarVendedor] =
    useState(false)
  const [mostrarFeedback, setMostrarFeedback] = useState(false)
  const [feedbackData, setFeedbackData] = useState(null)
  const [feedbackUser, setFeedbackUser] = useState(null)
  const [diarioVendedor, setDiarioVendedor] = useState({ id: undefined })
  const [mostrarEncerramento, setMostrarEncerramento] = useState(false)
  const [ultimoItemIndex, setUltimoItemIndex] = useState(null)

  const isMounted = useRef(true)

  const [showCelebration, setShowCelebration] = useState(false)

  useEffect(() => {
    isMounted.current = true
    if (props.state.dataFila.length > 0) {
      setUltimoItemIndex(props.state.dataFila.length - 1)
    }
    return () => {
      isMounted.current = false
    }
  }, [props.state.dataFila])

  function adicionarAtendimento (obj) {
    confirm({
      title: 'Adicionar atendimento',
      icon: <ExclamationCircleOutlined />,
      content: `Adicionar atendimento simultâneo para ${obj.user.apelido}?`,
      onOk () {
        if (isMounted.current) {
          editAtendimento({ self: props.self, user: obj.user })
        }
      },
    })
  }

  function abrirFeedback (obj) {
    setFeedbackUser(obj.user)
    setMostrarFeedback(true)
  }

  function fecharFeedback (feedbackId, vendedorId) {
    setMostrarFeedback(false)
    const vendedor = props.state.dataFila.find(item => item.id === vendedorId)

    const vendedorAtualizado = {
      ...vendedor,
      feedbacksPendentes: Math.max((vendedor.feedbacksPendentes || 0) - 1, 0),
    }

    props.atualizarVendedorNaFila(vendedorAtualizado)
    marcarFeedbackLido(feedbackId)
  }

  function btnIniciarAtendimentoClick (obj) {
    //   setShowCelebration(true)
    //   setTimeout(() => {
    //     setShowCelebration(false)
    //   }, 2000)

    //   return

    if (isMounted.current) {
      iniciarAtendimento(props.self, obj.user)
    }
  }

  function fecharEncerrarAtendimento () {
    setMostrarEncerramento(false)
  }

  function abrirModalAdicionarVendedor () {
    if (props.state.dataFila.length === 0) {
      setMostrarAdicionarVendedor(true)
    }
  }

  const onMenuMaisOpcoesClick = (item, user) => {
    if (item === 'sair') {
      setVendedor(user)
      setMostrarSaidaVendedor(true)
    } else if (item === 'ranking') {
      setDiarioVendedor({
        id: user.id,
        nome: user.nome,
        cpf: user.cpf,
        feedbacksPendentes: user.feedbacksPendentes,
        empresaId: props.self.state.user.id,
        visible: true,
        vendedores: [
          ...props.self.state.dataFila,
          ...props.self.state.dataAusente,
        ],
      })
    }
  }

  const onBotaoAcaoClick = (tipoAcao, usuario) => {
    if (tipoAcao === 'Adicionar Atendimento') {
      adicionarAtendimento({ user: usuario })
      return
    }
    setTipoEncerramento(tipoAcao)
    setVendedor(usuario)
    setMostrarEncerramento(true)
  }

  const [, drop] = useDrop({
    accept: 'card',
    drop: async (item, monitor) => {
      if (monitor.didDrop()) return
      const { index: dragIndex } = item
      const { index: hoverIndex } = monitor.getItem()
      const cards = [...props.state.dataAusente]
      const draggedCard = cards[dragIndex]
      cards.splice(dragIndex, 1)
      cards.splice(hoverIndex, 0, draggedCard)
      await entrarNaFila(
        props.self,
        draggedCard,
        props.state.dataFila,
        props.state.dataAusente,
      )
      if (props.self.state.config.exibirDesempenhoVendas) {
        setDiarioVendedor({
          id: draggedCard.id,
          nome: draggedCard.nome,
          cpf: draggedCard.cpf,
          empresaId: props.self.state.user.id,
          visible: true,
          vendedores: [
            ...props.self.state.dataFila,
            ...props.state.dataAusente,
          ],
        })
      }
    },
  })

  return (
    <div className='fila-vendedores-disponiveis-container'>
      {/* <SaleCelebration show={showCelebration} sellerName="Eduardo Chiletto" /> */}

      {mostrarFeedback && (
        <FeedbackWrapper
          visible={true}
          user={feedbackUser}
          onClose={(feedBackId, vendedorId) =>
            fecharFeedback(feedBackId, vendedorId)
          }
        />
      )}

      {mostrarAdicionarVendedor && (
        <AdicionarVendedorFilaWrapper
          mostrarAdicionarVendedor={mostrarAdicionarVendedor}
          setMostrarAdicionarVendedor={setMostrarAdicionarVendedor}
          dataFila={props.state.dataFila}
          dataAusente={props.state.dataAusente}
        />
      )}

      {mostrarEncerramento && (
        <EncerrarAtendimento
          self={props.self}
          visible
          vendedor={vendedor}
          motivos={props.state.motivos}
          onCancel={fecharEncerrarAtendimento}
          tipoEncerramento={tipoEncerramento}
        />
      )}

      {diarioVendedor.id && (
        <DiarioVendedor
          user={diarioVendedor}
          id={diarioVendedor.id}
          nome={diarioVendedor.nome}
          empresaId={diarioVendedor.empresaId}
          visible={diarioVendedor.visible}
          vendedores={diarioVendedor.vendedores}
          exigirSenhaDesempenhoVendas={
            props.self.state.config.exigirSenhaDesempenhoVendas
          }
          cpf={diarioVendedor.cpf}
          feedbacksPendentes={diarioVendedor.feedbacksPendentes}
          onClose={() =>
            setDiarioVendedor({
              id: '',
              nome: '',
              empresaId: '',
              visible: false,
            })
          }
        />
      )}

      <SairDaFila
        visible={mostrarSaidaVendedor}
        destroyOnClose
        vendedor={vendedor}
        onSubmit={async razao => {
          await ausentarVendedor(props.self, vendedor, razao.type, razao.value)
          setMostrarSaidaVendedor(false)
          return true
        }}
        onCancel={() => setMostrarSaidaVendedor(false)}
      />

      <div
        className='fila-vendedores-disponiveis'
        ref={drop}
        onClick={e => {
          e.stopPropagation()
          abrirModalAdicionarVendedor()
        }}
      >
        <div className='lista-vendedores-content'>
          <List
            className='lista-vendedores-diposniveis'
            loading={
              props.state.loading || props.state.aguardarProcessamentoFila
            }
            locale={{
              emptyText: (
                <Empty
                  imageStyle={{ height: 48 }}
                  className='adicionar-vendedores-empty-container'
                  image={<PlusCircleOutlined style={{ fontSize: 48 }} />}
                  description={
                    <div>
                      <strong className='adicionar-vendedores-empty-container-strong'>
                        Entrar na fila de atendimento
                      </strong>
                      <br />
                      <span className='adicionar-vendedores-empty-container-description'>
                        Toque para adicionar ou arraste alguém na lista abaixo
                        para colocá-lo na fila de atendimento
                      </span>
                    </div>
                  }
                />
              ),
            }}
            dataSource={props.state.dataFila}
            renderItem={(item, index) => (
              <List.Item
                key={item.id}
                style={{
                  border: 'ridge 1px',
                  backgroundColor: item.backgroundColor,
                }}
                className={index === ultimoItemIndex ? 'ultimo-item' : ''}
              >
                <List.Item.Meta
                  avatar={
                    <Badge
                      count={item.feedbacksPendentes || 0}
                      offset={[-5, 40]}
                      size='small'
                    >
                      <div
                        style={{
                          borderRadius: '50%',
                          padding: 1,
                          background:
                            'linear-gradient(135deg,rgb(32, 87, 170), #40A9FF)',
                          display: 'inline-block',
                        }}
                      >
                        <Avatar
                          src={item.avatar}
                          size={60}
                          style={{
                            border: '4px solid white',
                            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                            borderRadius: '50%',
                          }}
                        />
                      </div>
                    </Badge>
                  }
                  className='list-item-meta-avatar'
                  title={
                    <span className='nome-vendedor'>
                      {formatarNome(item.apelido || item.nome)}
                    </span>
                  }
                  description={
                    <div>
                      <p>{item.status.descricao}</p>
                      <Badge
                        className='sellerBadge'
                        count={<IconFont type={item.status.icon} size={20} />}
                      >
                        <CustomDateFNS date={item.status.data} interval={15} />
                      </Badge>
                    </div>
                  }
                />

                {!item.status.emAtendimento ? (
                  <div className='sellerButtons'>
                    <Button
                      className='btnIniciarAtendimento'
                      type='primary'
                      disabled={props.state.loading}
                      onClick={() => btnIniciarAtendimentoClick({ user: item })}
                    >
                      Atender
                    </Button>
                    <MenuMaisOpcoes
                      onItemClick={onMenuMaisOpcoesClick}
                      user={item}
                    />
                  </div>
                ) : (
                  <div className='sellerButtons'>
                    <BotaoAcaoFlutuante
                      user={item}
                      onBotaoAcaoClick={onBotaoAcaoClick}
                    />
                  </div>
                )}
              </List.Item>
            )}
          />
        </div>
      </div>
    </div>
  )
}

export default VendedoresDisponiveis
